function sendSentryAPIrequests(res="", error="") {
    const errorDetails = {
        status: res?.status,
        statusText: res?.statusText,
        response: res?.responseText,
        url: res?.responseURL || 'Unknown URL',
    };
    Sentry.withScope(scope => {
        scope.setTag('custom', 'custom_application_error');
        scope.setExtras(errorDetails);
        Sentry.captureException(error || new Error('AJAX request failed'));
    });
}

function sendSentryAPIrequestsXML(xhr, e) {
    const errorDetails = {
        status: xhr?.status ?? 'Unknown status',
        statusText: xhr?.statusText ?? 'Unknown statusText',
        response: xhr?.responseText ?? 'No responseText',
        url: xhr?.responseURL ?? 'Unknown URL',
    };

    Sentry.withScope(scope => {
        scope.setTag('custom', 'custom_application_error');
        scope.setExtras(errorDetails);

        // e が string の場合は new Error で包む
        const errorObj = e instanceof Error ? e : new Error(e || 'AJAX request failed');
        Sentry.captureException(errorObj);
    });
}